module.exports = __webpack_public_path__ + "media/images/favorchurch-a98d3fc2f72b9aeed4ef37d1d3af143c.png";